import React, { useEffect } from "react";
import PropTypes from "prop-types";

// context
import { useSearchBar } from "core/SearchBar/context/useSearchBar";

// component
const MountingWrapper = ({ children }) => {
    const {
        viewport: { device },
        setDropDown,
        searchMode
    } = useSearchBar();

    useEffect(() => {
        setDropDown(searchMode);
    }, [device, searchMode]);

    return <>{children}</>;
};

export default MountingWrapper;

// prop-types
MountingWrapper.propTypes = {
    children: PropTypes.any
};
